window.inputMask = function () {
    $('.js-input-mask').each(function () {
        const mask = $(this).data('mask');

        new Inputmask(
            {
                mask: mask,
                placeholder: '_',
                definitions: {
                    "F": {
                        validator: "[9]"
                    },
                    "G": {
                        validator: "[7]"
                    }
                },
            }
        ).mask(this);
    });

    $('.js-input-mask__inn').each(function () {
        const mask = $(this).data('mask');

        new Inputmask(
            {
                mask: mask,
                placeholder: '',
            }
        ).mask(this);
    });
}

inputMask();
